import BlPickerMv from './BlPickerMv.vue'

BlPickerMv.install = function(Vue) {
  Vue.component(BlPickerMv.name, BlPickerMv)
}

export default BlPickerMv
